import { useQuery } from '@tanstack/react-query'
import { getTopupConfig, TopupConfig } from 'api/highnote/topup'
import { highnoteKeys } from './keys'

export const useTopupConfig = () =>
  useQuery<TopupConfig>({
    queryKey: highnoteKeys.topupConfig(),
    queryFn: getTopupConfig,
  })
